export default __webpack_public_path__ + "static/media/FonsecaBold.6eaea453.otf";